import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import WindowSize from "./use-window-size";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-window-size"
    }}>{`use-window-size`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<WindowSize />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      WindowSize
    }} mdxType="Playground">
  <WindowSize mdxType="WindowSize" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useWindowSize } from "react-hooks-lab";

const WindowSize = () => {
  const { innerWidth, innerHeight } = useWindowSize(100);

  return (
    <div>
      window width: {innerWidth}
      <br />
      window height: {innerHeight}
    </div>
  );
};
export default WindowSize;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      